export default function(length) {
  let result = ''
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}



//////////////////
// WEBPACK FOOTER
// ./utils/randomString.js
// module id = null
// module chunks = 